module.exports = "https://static.wanderu.com/ui-react/_next/static/media/multimodal-grey.0c591eaf.svg";